import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, {
  IActionData,
  ITableColumn,
} from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import EditIcon from '@/components/Icons/EditIcon';
import PlusIcon from '@/components/Icons/PlusIcon';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import ConfirmModal from '@/components/Modal/ConfirmModal';
import useFilter from '@/hooks/useFilter';
import {
  ILeaveSettingPageState,
  ILeaveSettingResponse,
  IState,
} from '@/interfaces/leaveSetting.model';
import { RootState } from '@/redux/store';
import { getFilterUrl, showToastNotification } from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
export interface ITableData {
  id: string;
  index: number;
  leaveType: string;
  ApplFrom: string;
  TtlLeave: string;
  TtlLeaveYear: string;
}

const LeaveSetting = () => {
  const navigate = useNavigate();
  const [modal, setModal] = useState<boolean>(false);
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const toggle = () => setModal(!modal);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedId] = useState<string>('');
  const [state, setState] = useState<IState>({
    attendanceCount: null,
    leaveList: [],
  });
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const [pageStates, setPageStates] = useState<ILeaveSettingPageState>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    filterData: '',
    month: '',
    searchQuery: '',
  });
  const tableHeading: ITableColumn<ITableData>[] = [
    { value: 'index', label: '#' },
    { value: 'leaveType', label: 'Leave Type' },
    { value: 'ApplFrom', label: 'Appl. From' },
    { value: 'TtlLeave', label: 'Ttl. Leave(Mon)' },
    { value: 'TtlLeaveYear', label: 'Ttl. Leave(yr)' },
  ];

  useEffect(() => {
    getLeaveSettings();
  }, [
    pageStates?.currentPage,
    filterDetails?.pageSize,
    pageStates?.searchQuery,
  ]);

  const getLeaveSettings = async () => {
    try {
      const filterState = {
        pageNumber: pageStates?.currentPage,
        pageSize: filterDetails?.pageSize,
        all: true,
        search: pageStates.searchQuery,
      };
      setPageStates((prev) => ({
        ...prev,
        tableLoader: true,
      }));
      const API = `${API_URL}${API_ENDPOINT?.getLeaveSetting}?${getFilterUrl(filterState)}`;
      const response: ILeaveSettingResponse = await callApi(API, {
        method: 'GET',
      });
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response.status === true) {
        const newData: ITableData[] = response?.data?.map((item, index) => ({
          ...item,
          index: index + 1,
          leaveType: item?.type,
          ApplFrom: moment(item?.applicableFrom).format('MMMM Do YYYY'),
          TtlLeave: item?.totalLeavePerMonth,
          TtlLeaveYear: item?.totalLeavePerYear,
        }));
        setState((prev) => ({
          ...prev,
          leaveList: newData,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  // const ActionHandler = (data: ITableData) => {
  //   setSelectedId(data?.id);
  //   toggle();
  // };

  const HandleDelete = async () => {
    try {
      const API = `${API_URL}${API_ENDPOINT.deleteLeaveSetting}?leaveId=${selectedId}`;
      setIsLoading(true);
      const response: ILeaveSettingResponse = await callApi(API, {
        method: 'GET',
      });
      setIsLoading(false);
      if (response?.status === true) {
        showToastNotification('success', response?.message);
        toggle();
        getLeaveSettings();
      } else {
        showToastNotification('danger', response?.message);
        toggle();
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const ActionData: IActionData<ITableData>[] = [
    {
      label: 'Edit',
      className: 'btn btn-link',
      icon: <EditIcon />,
      title: 'edit',
      clickHandler: (data: ITableData) => {
        navigate(RoutesLink?.addLeaveSetting, { state: { EditData: data } });
      },
    },
    // {
    //   label: 'Delete',
    //   className: 'btn btn-link',
    //   icon: <DeleteIcon />,
    //   title: 'delete',
    //   clickHandler: ActionHandler,
    // },
  ];

  const { pageChangeHandler, handleSearchChange, handleChangePageSize } =
    useFilter(pageStates, setPageStates);

  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading
            title={'Leave Settings'}
            buttonText={'Add Leave Settings'}
            buttonIcon={<PlusIcon />}
            buttonLink={RoutesLink?.addLeaveSetting}
          />
          <CardLayout cardStyle="mb-4" isGrid={tableView === 'grid'}>
            <FilterComponent handleSearch={handleSearchChange} isGrid={false} />
            <CommonTable
              tableHeading={tableHeading}
              tableData={state?.leaveList}
              ActionData={ActionData}
              count={pageStates?.count}
              pageSize={filterDetails?.pageSize}
              isLoading={pageStates?.tableLoader}
              currentPage={pageStates?.currentPage}
              totalPages={pageStates?.totalPages}
              pageChangeHandler={pageChangeHandler}
              handleChangePageSize={handleChangePageSize}
            />
          </CardLayout>
        </div>
      </Layout>
      <ConfirmModal
        isOpen={modal}
        toggle={toggle}
        isLoading={isLoading}
        submitHandler={HandleDelete}
      />
    </>
  );
};

export default LeaveSetting;
